import React from "react";
import TranslatedPage from "../TranslatedPage";
import IconFromPath from "../TranslatedPage/IconFromPath";

const AdvantagesSection = () => {
  return (
    <section>
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading why-co-own">
            <TranslatedPage path="home.content_blocks.advantages_of_co_owning_header.heading" />
          </h1>
          <div className="feature-list large how-it-works">
            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="40"
                  className="icon primary-color"
                  path="home.content_blocks.advantages_of_co_owning_save_money.icon"
                  custom={true}
                />
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_money.heading" />
                </h2>
                <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_money.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="36"
                  className="icon primary-color"
                  path="home.content_blocks.advantages_of_co_owning_save_storage.icon"
                  custom={false}
                />
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_storage.heading" />
                </h2>
                <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_storage.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="40"
                  className="icon primary-color"
                  path="home.content_blocks.advantages_of_co_owning_save_environment.icon"
                  custom={true}
                />
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_environment.heading" />
                </h2>
                <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_environment.content" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
